import * as Constants from './constants'

export const labelFor = (key: string): string => Constants.LABELS[key] ? Constants.LABELS[key].label : key
export const helpKeyFor = (key: string): string => Constants.LABELS[key] ? Constants.LABELS[key].helpKey : key



// WEBPACK FOOTER //
// ./src/pages/newsbrief/counts/utils.ts